import { Outlet } from "react-router-dom";

export function ZoneLayout() {
  return (
    <div>
      <Outlet />
    </div>
  );
}
